let linksDesktop = document.querySelectorAll('.header__menu-item');
let linksLeftSubmenuDesktop = document.querySelectorAll('.mega-menu__left-item');
let linksRightSubmenuDesktop = document.querySelectorAll('.mega-menu__right-item_link, .mega-menu__right-item__image');

linksDesktop.forEach(link => {
  link.addEventListener('click', () => {
        let clickText = link.querySelector('span').textContent.trim();
        let clickUrl = link.getAttribute('href');
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
        event: "click_menu_principal",
        link_text: clickText,
        link_url: clickUrl,
    });
  });
});

linksLeftSubmenuDesktop.forEach(link => {
    link.addEventListener('click', (e) => {
            let clickText = e.target.closest('.mega-menu__left-item').querySelector('span').textContent.trim();
            let clickUrl = link.querySelector('a').getAttribute('href');
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
            event: "click_submenu_principal",
            link_text: clickText,
            link_url: clickUrl,
        });
    });
});

linksRightSubmenuDesktop.forEach(link => {
            link.addEventListener('click', (e) => {
                let clickText = e.target.closest('.mega-menu__content').querySelector('.mega-menu__subtitle').textContent.trim();
                let clickUrl = link.getAttribute('href');
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                event: "click_submenu_secundario",
                link_text: clickText,
                link_url: clickUrl
        });
    });
});

// Menú mobile 

let hamburguerMobile = document.querySelector('.icon-hamburger');
let linksMobile = [
    ...document.querySelectorAll('.new-sidebar__nav .main-sidebar-link__icon'),
    ...document.querySelectorAll('.new-sidebar__nav .main-sidebar-link__title')
];
let linksSubmenuMobile = document.querySelectorAll('.sidebar-child-link');
let buttonViewAllMobile = document.querySelectorAll('.main-sidebar-link__view-all-button');

hamburguerMobile.addEventListener('click', () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
    event: "click_menu_principal",
    link_text: "mobile",
    link_url: "open_menu_mobile",
    });
});

linksMobile.forEach(link => {
        link.addEventListener('click', () => {
            let clickText = link.textContent.trim();
            let clickUrl = link.getAttribute('href');
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ 
            event: "click_submenu_principal_mobile",
            link_text: clickText,
            link_url: clickUrl,
        });
    });
});

linksSubmenuMobile.forEach(link => {
        link.addEventListener('click', () => {
            let clickUrl = link.querySelector('a').getAttribute('href');
            let clickText = link.querySelector('.child-link-item__content-inner-title').textContent.trim();
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
            event: "click_submenu_secundario_mobile",
            link_text: clickText,
            link_url: clickUrl,
        });
    });
});

buttonViewAllMobile.forEach(link => {
        link.addEventListener('click', () => {
            let clickUrl = link.getAttribute('href');
            let clickText = link.textContent.trim();
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
            event: "click_boton_viewall_mobile",
            link_text: clickText,
            link_url: clickUrl,
        });
    });
});